import React from "react";

import "./styles.css";

// Import the CSS file
const CircularSpinner = () => {
  return (
    <div className="spinner-container">
      <svg
        className="spinner"
        //   width="65"
        height="65"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="path"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  );
};

export default CircularSpinner;
